import React, { Fragment, useEffect, useState } from "react";
import { AnimatedText } from "../FooterStyled";

export default function ButtonText({ st, win, curr, lastCardRotated }: any) {
  const [btnContent, setbtnContent] = useState<string>("Play");

  const handleBtnContent = (st: number) => {
    st === 2
      ? setbtnContent("Deal")
      : st === 3
      ? setbtnContent("Collect")
      : setbtnContent("Play");
  };

  useEffect(() => {
    lastCardRotated && handleBtnContent(st);
  }, [st, lastCardRotated]);

  return (
    <Fragment>
      <AnimatedText fadeOut={btnContent !== "Play"}>Play</AnimatedText>
      <AnimatedText fadeOut={btnContent !== "Deal"}>Deal</AnimatedText>
      <AnimatedText fadeOut={btnContent !== "Collect"}>
        Collect
        <span>
          {win} {curr}
        </span>
      </AnimatedText>
    </Fragment>
  );
}
